(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      if (!this.header) return;

      this.headerIsAlwaysSticky = true;

      this.setHeaderHeight();
      window.addEventListener('resize', this.setHeaderHeight.bind(this));

      this.header.classList.add('shopify-section-header-sticky');
    }

    setHeaderHeight() {
      if (!this.header) return;
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      window.removeEventListener('resize', this.setHeaderHeight);
    }

    createObserver() {}
    onScroll() {}
    hide() {}
    reveal() {}
    reset() {}
    closeMenuDisclosure() {}
    closeSearchModal() {}
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();
})();
